<template>

    <!-- CHAT DRAWER -->
    <v-navigation-drawer
        v-model="componentVisible"
        dark
        right
        fixed
        app
        width="380"
        clipped
        temporary
    >
        <v-list class="pa-1">
            <v-list-item>
                <v-list-item-avatar>
                    <v-icon>mdi-message-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>Team chat</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
        </v-list>

        <v-card flat>
            <v-card-text>
                <v-textarea
                    :loading="sending"
                    solo
                    background-color="grey darken-2"
                    label="Say something..."
                    rows="2"
                    hide-details
                    autofocus
                    @keyup.enter="sendTeamMessageClicked"
                    v-model="messageModel"
                ></v-textarea>
            </v-card-text>
        </v-card>

        <chat-bubble-list :messages="teamMessages"/>

    </v-navigation-drawer>
</template>

<script>

import ChatBubbleList from "./ChatBubbleList";
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
import moment from "moment";
import {timeDisplay} from "../../../components/mixins/timeDisplayMixin";

const vuexModule = 'Chat';

export default {

    mixins: [timeDisplay],

    components: {
        ChatBubbleList
    },

    data() {
        return {
            menuClipped: false,
            componentVisible: false,
            messageModel: '',
            users: [],
            sending: false,
        }
    },

    computed: {

        ...mapState(['echo']),

        ...mapState(vuexModule, [
            'teamMessages'
        ]),

        panelUuid() {
            if (this.$store.state.PanelSettings.settings.uuid) {
                return this.$store.state.PanelSettings.settings.uuid;
            }
        },

        currentUserId() {
            if (this.$store.state.user.id) {
                return this.$store.state.user.id;
            }
        },
    },

    watch: {

        componentVisible() {
            this.markTeamMessagesSeen();
        },

        panelUuid(uuid) {
            this.joinChatChannel(uuid);
            this.joinPrivateChatChannel(uuid);
        }
    },

    methods: {

        ...mapActions(vuexModule, [
            'sendTeamMessage'
        ]),

        ...mapMutations(vuexModule, [
            'addTeamMessage',
            'addPrivateMessage',
            'setChatUsers',
            'addChatUser',
            'removeChatUser',
            'markTeamMessagesSeen',
            'initializeTeamMessages'
        ]),

        joinChatChannel(panelUuid) {

            // Check if the connection is around
            if (typeof this.echo !== 'undefined') {

                const channelName = 'ChatChannel.Team.' + panelUuid;

                // Listen for events
                this.echo.join(channelName)
                    .here(users => {
                        this.setChatUsers(users);
                    })
                    .joining(user => {
                        this.addChatUser(user);
                    })
                    .leaving(user => {
                        this.removeChatUser(user);
                    })
                    .listen('ChatMessageTeamEvent', (e) => {
                        this.addTeamMessage({user: e.user, message: e.message});
                        const audio = new Audio('/sounds/chatmessage.wav');
                        audio.volume = 0.5;
                        audio.play();
                    });
            }
        },

        joinPrivateChatChannel(panelUuid) {

            // Check if the connection is around
            if (typeof this.echo !== 'undefined') {

                const channelName = 'ChatChannel.Private.' + panelUuid + '.User.' + this.currentUserId;

                // Listen for events
                this.echo.private(channelName)
                    .listen('ChatMessagePrivateEvent', (e) => {
                        this.addPrivateMessage({
                            user: e.user,
                            message: e.message,
                            set: this.$set,
                            receiver: e.user.id
                        });
                        const audio = new Audio('/sounds/privatemessage.mp3');
                        audio.volume = 0.8;
                        audio.play();
                    });
            }
        },

        sendTeamMessageClicked() {

            const user = this.$store.state.user;

            this.sending = true;

            this.sendTeamMessage({user: this.$store.state.user, message: this.messageModel})

                .then(() => {
                    this.addTeamMessage({
                        message: this.messageModel,
                        user: {
                            id: user.id,
                            name: user.name,
                            photo_url: user.photo_url,
                        }
                    });

                    const audio = new Audio('/sounds/chatmessage.wav');
                    audio.volume = 0.5;
                    audio.play();

                    this.messageModel = '';
                })
                .catch(() => {
                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'We are sorry you message failed to send. Try again later.'
                    });
                })
                .finally(() => {
                    this.sending = false;
                });

        },

        isOlderThanToday(createdAt) {
            return false;
        },
    },

    mounted() {
        this.initializeTeamMessages();
    },

    created() {

        Bus.$on('chat-drawer-toggle', () => {
            this.componentVisible = !this.componentVisible;
        });

        Bus.$on('chat-drawer', (value) => {
            this.componentVisible = value;
        });
    },
};

</script>
